export default class PicksFormValidator {

    constructor() {
        this.form = document.getElementById("my-picks-form");
        if (!this.form) return;

        this.init();
    }

    init() {
        this.refreshElements();
        this.form.addEventListener("submit", (e) => this.handleSubmit(e));
        this.bindInputListeners();
        this.updatePicksCount();
        this.updateTotalMatchups();
    }

    refreshElements() {
        this.matchups = [...this.form.querySelectorAll(".matchup")];
        this.tieBreakerInputs = [...this.form.querySelectorAll(".score-prediction input")];
        this.totalPicksElem = document.querySelector(".picks-made .total-picks");
        this.totalMatchupsElem = document.querySelector(".picks-made .total-matchups");
        this.hasErrorsElem = document.querySelectorAll(".has-errors");
    }

    handleSubmit(e) {
        this.refreshElements(); 
        let valid = true;

        this.matchups.forEach(matchup => {
            matchup.classList.remove("error");

            if (matchup.hasAttribute('data-is-skipped')) return; 

            if (!this.validateRadio(matchup)) {
                matchup.classList.add("error");
                valid = false;
            }
        });

        if (!this.validateTieBreakers()) {
            valid = false;
        }

        if (!valid) {
            e.preventDefault();
            this.scrollToFirstError();
            if (this.hasErrorsElem.length) {
                this.hasErrorsElem.forEach(el => el.classList.add("show"));
            }
        }
    }

    validateRadio(matchup) {
        const selected = matchup.querySelector('input[type="radio"]:checked');
        return !!selected;
    }

    validateTieBreakers() {
        let tieValid = true;
        this.tieBreakerInputs.forEach(input => {
            const matchup = input.closest(".matchup");
            
            if (matchup && matchup.hasAttribute('data-is-skipped')) return;

            if (input.value.trim() === "" && !input.disabled) {
                if (matchup) matchup.classList.add("error");
                input.classList.add("error");
                tieValid = false;
            }
        });
        return tieValid;
    }

    bindInputListeners() {
        this.form.addEventListener("change", (e) => {
            const input = e.target;
            const matchup = input.closest(".matchup");
            
            if (matchup) {
                matchup.classList.remove("error");

                // Handle Home/Away Class toggling
                if (input.type === "radio") {
                    const label = input.nextElementSibling;
                    const typeDiv = label ? label.querySelector('.home-or-away') : null;
                    
                    if (typeDiv) {
                        const isHome = typeDiv.textContent.trim().toLowerCase() === 'home';
                        
                        matchup.classList.remove("home-team-picked", "away-team-picked");
                        matchup.classList.add(isHome ? "home-team-picked" : "away-team-picked");
                    }
                }
            }

            this.updatePicksCount();
        });
    }

    updatePicksCount() {
        if (!this.totalPicksElem) return;
        let count = 0;
        let activeMatchups = 0;

        this.matchups.forEach(matchup => {
            if (!matchup.hasAttribute('data-is-skipped')) {
                activeMatchups++;
                if (matchup.querySelector('input[type="radio"]:checked')) count++;
            }
        });

        this.totalPicksElem.textContent = count;
    }

    updateTotalMatchups() {
        if (!this.totalMatchupsElem) return;
        const activeCount = this.matchups.filter(m => !m.hasAttribute('data-is-skipped')).length;
        this.totalMatchupsElem.textContent = activeCount;
    }

    scrollToFirstError() {
        const firstError = this.form.querySelector(".matchup.error");
        if (firstError) {
            firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }
}